import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { 
  Menu, X, Users, Calendar, Video, MessageCircle, Briefcase,
  Presentation, Sparkles, TrendingUp, Layout, Image as ImageIcon,
  Home, LogOut, User, CreditCard, FileText, Settings
} from 'lucide-react';
import { getUser, clearAuth } from '../lib/auth';

const SidebarNavigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const user = getUser();

  const handleLogout = () => {
    clearAuth();
    navigate('/auth');
  };

  const navItems = [
    { path: '/', icon: <Home className="w-5 h-5" />, label: 'Home' },
    { path: '/digi-connect', icon: <Users className="w-5 h-5" />, label: 'Digi Connect' },
    { path: '/digi-meet', icon: <Video className="w-5 h-5" />, label: 'Digi Meet' },
    { path: '/digi-calendar', icon: <Calendar className="w-5 h-5" />, label: 'Digi Calendar' },
    { path: '/community', icon: <MessageCircle className="w-5 h-5" />, label: 'Community' },
    { path: '/community-videos', icon: <Video className="w-5 h-5" />, label: 'Community Videos' },
    // { path: '/ai-team', icon: <Sparkles className="w-5 h-5" />, label: 'Digi Squad (AI)' },
    // { path: '/digi-strategy', icon: <TrendingUp className="w-5 h-5" />, label: 'Digi Strategy' },
    { path: '/crm-leads', icon: <Briefcase className="w-5 h-5" />, label: 'Digi CRM' },
    { path: '/website-builder', icon: <Layout className="w-5 h-5" />, label: 'Website Builder' },
    { path: '/events', icon: <Calendar className="w-5 h-5" />, label: 'Events' },
    // { path: '/digi-branding', icon: <Sparkles className="w-5 h-5" />, label: 'Digi Branding' },
    // { path: '/digi-editor', icon: <ImageIcon className="w-5 h-5" />, label: 'Digi Editor' },
    { path: '/presentor', icon: <Presentation className="w-5 h-5" />, label: 'Presentor' },
    // DigiSlides Pro removed
  ];

  return (
    <>
      {/* Hamburger Menu Button */}
      <button
        onClick={() => setIsOpen(true)}
        className="fixed top-4 left-4 z-40 p-2 bg-slate-900 text-white rounded-lg shadow-lg hover:bg-slate-800 transition-colors"
        aria-label="Open menu"
      >
        <Menu className="w-6 h-6" />
      </button>

      {/* Overlay */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* Sidebar */}
      <div className={`fixed top-0 left-0 h-full w-80 bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-in-out overflow-y-auto ${
        isOpen ? 'translate-x-0' : '-translate-x-full'
      }`}>
        <div className="flex flex-col h-full">
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-slate-200">
            <div>
              <h2 className="text-xl font-bold text-slate-900" style={{fontFamily: 'Space Grotesk, sans-serif'}}>
                DigiDreamSolutions
              </h2>
              <p className="text-sm text-slate-600">{user?.name}</p>
            </div>
            <button
              onClick={() => setIsOpen(false)}
              className="p-2 hover:bg-slate-100 rounded-lg transition-colors"
              aria-label="Close menu"
            >
              <X className="w-6 h-6 text-slate-600" />
            </button>
          </div>

          {/* Navigation Links */}
          <nav className="flex-1 py-4">
            {navItems.map((item) => {
              const isActive = location.pathname === item.path;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsOpen(false)}
                  className={`flex items-center gap-3 px-6 py-3 transition-colors ${
                    isActive
                      ? 'bg-blue-50 text-blue-600 border-r-4 border-blue-600'
                      : 'text-slate-700 hover:bg-slate-50'
                  }`}
                >
                  {item.icon}
                  <span className="font-medium">{item.label}</span>
                </Link>
              );
            })}
          </nav>

          {/* Footer Actions */}
          <div className="border-t border-slate-200 p-4 space-y-2">
            <Link
              to="/profile/edit"
              onClick={() => setIsOpen(false)}
              className="flex items-center gap-3 px-4 py-3 text-slate-700 hover:bg-slate-50 rounded-lg transition-colors"
            >
              <User className="w-5 h-5" />
              <span>Edit Profile</span>
            </Link>
            <Link
              to="/pricing"
              onClick={() => setIsOpen(false)}
              className="flex items-center gap-3 px-4 py-3 text-slate-700 hover:bg-slate-50 rounded-lg transition-colors"
            >
              <CreditCard className="w-5 h-5" />
              <span>Pricing</span>
            </Link>
            <button
              onClick={handleLogout}
              className="flex items-center gap-3 px-4 py-3 text-red-600 hover:bg-red-50 rounded-lg transition-colors w-full"
            >
              <LogOut className="w-5 h-5" />
              <span>Logout</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default SidebarNavigation;
